import { NumberCons, StringConst } from 'src/app/constants/const';
import { ProductItem } from '../http/prescriptionName';


export class PrescriptionNamesView {
  numPrescription: number;
  name: string;
  isNamePrinted: number;
  diagnosis: string;
  gender: string;
  products: ProductItem[];
  dosage: string;
  birthDate: string;
  constructor() {
    this.numPrescription = NumberCons.zero;
    this.name = StringConst.empty;
    this.isNamePrinted = NumberCons.zero;
    this.diagnosis = StringConst.empty;
    this.gender = StringConst.empty;
    this.products = [];
    this.dosage = StringConst.empty;
    this.birthDate = StringConst.empty;
  }
}
